import { IApplicationState } from 'setup/store'

export const selectSettings = (state: IApplicationState) => state.settings.data

export const selectRates = (state: IApplicationState) => state.settings.data.settings.rates
export const selectLimits = (state: IApplicationState) => state.settings.data.settings.limits
export const selectMinBet = (state: IApplicationState) => state.settings.data.settings.limits.minBet

export const selectCurrenciesList = (state: IApplicationState) => state.settings.data.currencies
export const selectCurrenciesListLoading = (state: IApplicationState) =>
  state.settings.communications.getCurrenciesList.isLoading
